// The loaded favorite list holds the smallest wishlist ids, so it is exact for every id up to lastLoadedId —
// and for every id when the wishlist fits one page. Larger ids of a bigger wishlist must ask the server.
const isFavoriteKnownFromList = (materialId: number, favorite: Pick<Favorite, 'isTruncated' | 'lastLoadedId'>) =>
    !favorite.isTruncated || materialId <= (favorite.lastLoadedId ?? 0);

export default isFavoriteKnownFromList;
